// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_2u-1";
export var rateTableServiceLevelDropdown = "_2u-3";
export var rateTableTypeDropdown = "_2u-0";
export var rateTableValueModeDropdown = "_2u-2";